import { createSelector } from 'reselect';
import getModuleState from './moduleStateSelector';
import { BUNDLE_TYPES } from '../constants/packagesConstants';

export const getFilters = createSelector(
  getModuleState,
  (state) => state.get('filters')
);

export const getIsPartialRoomStay = createSelector(
  getFilters,
  (filters) => filters.get('isPartialRoomStay')
);

export const getPartialDates = createSelector(
  getFilters,
  (filters) => ({
    startDate: filters.get('partialRoomStartDate'),
    endDate: filters.get('partialRoomEndDate'),
  })
);

export const getIsNonStop = createSelector(
  getFilters,
  (filters) => filters.get('isNonStop')
);

export const getBundleType = createSelector(
  getFilters,
  (filters) => filters.get('bundleType')
);

export const getAirline = createSelector(
  getFilters,
  (filters) => filters.get('airline')
);

export const getFlightClass = createSelector(
  getFilters,
  (filters) => filters.get('flightClass')
);

export const getHasRooms = createSelector(
  getBundleType,
  (bundleType) => bundleType !== BUNDLE_TYPES.AIR_CAR
);

export const getIsDriversAgeWithinRange = createSelector(
  getFilters,
  (filters) => filters.get('isDriversAgeWithinRange')
);

export const getDriversAge = createSelector(
  getFilters,
  (filters) => filters.get('driversAge')
);
